export const text = {
  News: "News",
  AddNews: "Add News",
  NewsOrder: "News Order",
  Author: "Author",
  ModifiedDate: "Modified Date",
  Article: "Article",
  NewsDeletedsuccessfully: "News Deleted successfully!",
  Newsaddedsuccessfully: "News added successfully!",
  Newsupdatedsuccessfully: "News updated successfully!",
  EnterTitle: "Enter Title",
  EnterAuthor: "Enter Author",
  EnterSubtitle: "Enter Subtitle",
  Order: "Order",
  AssignTeam: "Assign Team",
  choosebanner: "Choose Banner",
  choosevideo: "Choose Video",
  ForTeam: "For Team",
  Content: "Content",
  Banner: "Banner",
  Author: "Author",
};
